<template>
  <div class="container">
    <div class=" w-100 " >
      <h1 v-if="!$device.isMobile">Account</h1>
      <h2 v-else class="text-center">Account</h2>
      <div class="m-y-3 m-r-auto d-flex w-100 jc-between:mo bd-b-gray30 ">
        <div
            v-for="(link, mIndex) in $options.LINKS.account"
            :key="mIndex"
            class="m-r-3 m-x-1:mo ">
          <router-link
              :to="{name: link.name}"
              class="account-link m-l-auto:d"
              :class="{ 'active-account-link': link.name === currentSubRouteName }"
              :selenium="`header-${link.label}-link`">
            {{link.label}}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LINKS from '@/layouts/components/newAppHeaderPro/links-constant';

export default {

  LINKS,
  name: 'account-header',
  computed: {
    currentSubRouteName () {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.active-account-link {
  color: $color-depot !important;
  padding-bottom: $unit * 2;
  border-bottom: 5px solid $color-depot;
}
.account-link {
    color: #000;
    font-size: 16px;
    font-weight: bold;
    text-transform: capitalize;
    cursor: pointer;
    display:flex;
    align-items: end;
    justify-items: flex-end;
    flex-direction: column;
    @include mobile-only {
      font-size: 12px;
      font-weight: 600;
    }
}
.router-link-exact-active{
    color: $color-depot;
}

</style>
